import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { EmoticonReaction } from './emoticon-reaction.type';

@Component({
    selector: 'tm-emoticon-reactions',
    templateUrl: './emoticon-reactions.component.html',
    styleUrls: ['./emoticon-reactions.component.scss'],
    imports: [
        MatTooltipModule,
        TranslateModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmoticonReactionsComponent {
  @Input()
  reactions: EmoticonReaction[];
}

